export function maskNIF(nif: string | null | undefined): string {
  if (!nif || nif.trim() === '') return '';

  if (nif.length <= 4) {
    return nif;
  }

  const lastChars = nif.slice(-4);
  const masked = '*'.repeat(nif.length - 4) + lastChars;
  return masked;
}

export function shouldMaskSensitiveData(): boolean {
  return true;
}
